(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

(function ($) {
  'use strict';

  kiwijs.AjaxHandler = function (formElement, url, successFunction, errorFunction) {
    var self = this;
    this.$form = formElement;
    this.$inlineMessages = formElement.parents('.modal-content').find('[class*=\'inline-messages\']');
    this.url = url;
    this.success = successFunction;
    this.error = errorFunction;

    this.getFormData = function () {
      var data = {};
      this.$form.find('input').each(function () {
        // Do not submit checkboxes that are unchecked
        if (!($(this).is(':checkbox') && !$(this).is(':checked'))) {
          data[$(this).attr('name')] = $(this).val();
        }
      });
      var formRecaptchaValue = self.getCaptchaWidgetValue();

      if (formRecaptchaValue) {
        data['g-recaptcha-response'] = formRecaptchaValue;
      }

      return data;
    };

    this.getCaptchaWidgetId = function () {
      var self = this;
      var captchaWidget = self.$form.find('.g-recaptcha');
      var captchaWidgetId = null;

      if (captchaWidget.length) {
        var widgetId = captchaWidget.data('widget-id');

        if (typeof widgetId !== 'undefined') {
          captchaWidgetId = widgetId;
        }
      }

      return captchaWidgetId;
    };

    this.getCaptchaWidgetValue = function () {
      var self = this;
      var captchaValue = null;

      if (typeof grecaptcha !== 'undefined') {
        try {
          var captchaWidgetId = self.getCaptchaWidgetId();
          captchaValue = grecaptcha.getResponse(captchaWidgetId);
        } catch (e) {}
      }

      return captchaValue;
    };

    this.resetCaptcha = function () {
      if (typeof grecaptcha !== 'undefined') {
        var captchaWidgetId = self.getCaptchaWidgetId();

        if (captchaWidgetId !== null) {
          grecaptcha.reset(captchaWidgetId);
        }
      }
    };

    this.submitForm = function () {
      $.ajax({
        url: self.url,
        type: 'post',
        data: self.getFormData(),
        cache: false,
        success: function success(data) {
          if (typeof self.success === 'function') {
            self.success(data);
          }

          if (!data.success) {
            self.resetCaptcha();
            self.$form.find('button:disabled').prop('disabled', false);
          }
        },
        error: function error(data) {
          if (500 === data.status && !data.responseJSON) {
            // This handles all 500 errors that do not contain a json response
            var error = [{
              'message': 'Internal Server Error'
            }];
            self.attachFormErrors(error);
            self.$form.find('button:disabled').prop('disabled', false);
          } else if (400 === data.status && data.responseJSON.token) {
            //todo: make sure this is not triggered recursively
            self.$form.find('input[name*=\'\\[_token\\]\']').val(data.responseJSON.token);
            self.submitForm();
          } else {
            self.$form.find('button:disabled').prop('disabled', false);
            self.resetCaptcha();

            if (typeof self.error === 'function') {
              self.error(data);
            }
          }
        }
      });
    };

    this.$form.on('submit', function (e) {
      if (self.$form[0].jsFormValidator.isValid()) {
        e.preventDefault(e);
        self.submitForm();
      }
    });

    this.attachFormErrors = function (errors) {
      var formName = this.$form.attr('name');
      self.$inlineMessages.find('.' + JsFormValidator.errorClass).children().remove();
      self.$inlineMessages.hide();
      errors.forEach(function (error, index) {
        var $input = self.$form.find('input[name=\'' + formName + '[' + error.field + ']\']');

        if ($input.length > 0) {
          var $error_list = $input.find('.' + JsFormValidator.errorClass);

          if ($error_list.length > 0) {
            $error_list.append('<li>' + error.message + '</li>');
          } else {
            $input.after('<ul class="' + JsFormValidator.errorClass + '"><li>' + error.message + '</li></ul>');
          }

          $input.addClass(JsFormValidator.fieldErrorClass);
        } else {
          self.$inlineMessages.find('.' + JsFormValidator.errorClass).append('<li>' + error.message + '</li>');
        }
      });
      self.$inlineMessages.parent().show();
      self.$inlineMessages.show();
      self.$form.parents('.modal-content').find('.flash-message').attr('tabindex', '-1').focus();
    };

    if (this.$form.length > 0) {
      this.$form[0].submitFunction = this.submitForm;
    } else {
      this.$form.submitFunction = this.submitForm;
    }
  };

  kiwijs.ForgotPasswordAjaxHandler = function (formElement) {
    var self = this;
    this.successModal = kiwijs.accountModals.modals['account-forgot-password-success'];

    this.success = function (data) {
      if (data.success) {
        self.successModal.openModal();
        self.successModal.$modal.find('.forgotten-email').text(data.email);
      } else {
        self.attachFormErrors(data.responseJSON.errors);
      }
    };

    this.error = function (data) {
      self.attachFormErrors(data.responseJSON.errors);
    };

    kiwijs.AjaxHandler.call(this, formElement, '/account/forgot/ajax', this.success, this.error);
  };

  kiwijs.ResetPasswordAjaxHandler = function (formElement) {
    var self = this;
    this.errorModal = kiwijs.accountModals.modals['account-reset-password-error'];
    this.successModal = kiwijs.accountModals.modals['account-authenticate'];

    this.success = function (data) {
      if (data.success) {
        kiwijs.ajaxHandlers.forms.loginForm.$inlineMessages.removeClass('error');
        kiwijs.ajaxHandlers.forms.loginForm.$inlineMessages.addClass('message');
        kiwijs.ajaxHandlers.forms.loginForm.$inlineMessages.find('.' + JsFormValidator.errorClass).append('<li>' + data.message + '</li>');
        kiwijs.ajaxHandlers.forms.loginForm.$inlineMessages.parent().show();
        kiwijs.ajaxHandlers.forms.loginForm.$inlineMessages.show();
        self.successModal.openModal('login');
      } else {
        self.errorModal.openModal();
      }
    };

    this.error = function (data) {
      self.attachFormErrors(data.responseJSON.errors);
    };

    kiwijs.AjaxHandler.call(this, formElement, '/account/reset', this.success, this.error);
  };

  kiwijs.RegisterAjaxHandler = function (formElement) {
    var self = this;
    this.successModal = kiwijs.accountModals.modals['account-register-success'];

    this.error = function (data) {
      self.attachFormErrors(data.responseJSON.errors);
    };

    this.success = function (data) {
      if (data.success) {
        window.location.reload(true);
      } else {
        self.attachFormErrors(data.errors);
        kiwijs.accountModals.modals['account-forgot-password'].setUpTriggers();
      }
    };

    kiwijs.AjaxHandler.call(this, formElement, '/account/signup', this.success, this.error);
    this.$inlineMessages = formElement.parents('.content-toggle').find('[class*=\'inline-messages\']');
  };

  kiwijs.VerifyEmailAjaxHandler = function (formElement) {
    var self = this;
    this.successModal = kiwijs.accountModals.modals['account-verify-email-success'];

    this.error = function (data) {
      self.attachFormErrors(data.responseJSON.errors);
    };

    this.success = function (data) {
      if (data.success) {
        window.location.reload(true);
      } else {
        self.attachFormErrors(data.errors);
      }
    };

    kiwijs.AjaxHandler.call(this, formElement, '/account/login/ajax', this.success, this.error);
    this.$inlineMessages = formElement.parents('.modal-content').find('[class*=\'inline-messages\']');

    this.getFormData = function () {
      var username = self.$form.find('input[name*=\'\\[email\\]\']').val();
      var password = self.$form.find('input[name*=\'\\[password\\]\']').val();
      var token = self.$form.find('input[name*=\'\\[_token\\]\']').val();
      var data = {};
      var formRecaptchaValue = self.getCaptchaWidgetValue();

      if (formRecaptchaValue) {
        data['g-recaptcha-response'] = formRecaptchaValue;
      }

      data['login[email]'] = username;
      data['login[password]'] = password;
      data['login[_token]'] = token;

      if (!(self.$form.find('input[name*=\'\\[_remember_me\\]\']').is(':checkbox') && !self.$form.find('input[name*=\'\\[_remember_me\\]\']').is(':checked'))) {
        data['login[_remember_me]'] = 1;
      }

      return data;
    };
  };

  kiwijs.LoginAjaxHandler = function (formElement) {
    var self = this;
    this.$modal = kiwijs.accountModals.modals['account-authenticate'];

    this.success = function (data) {
      if (data.success) {
        window.location.reload(true);
      } else {
        self.attachFormErrors(data.errors);
      }
    };

    this.error = function (data) {
      self.attachFormErrors(data.responseJSON.errors);
    };

    kiwijs.AjaxHandler.call(this, formElement, '/account/login/ajax', this.success, this.error);
    this.$inlineMessages = formElement.parents('.content-toggle').find('[class*=\'inline-messages\']');
  };

  kiwijs.NewsletterInlineAjaxHandler = function (formElement) {
    var self = this;
    var successClass = 'success_message';
    var emailField = formElement.find('input[type=email]');
    var formActionUrl = formElement.attr('action');

    if (emailField.length && formActionUrl) {
      var successMessageContainer = $('<div>', {
        class: successClass
      });
      emailField.on('focus', function () {
        successMessageContainer.hide();
      });

      this.success = function (data) {
        emailField.val('');
        emailField.blur();

        if (!emailField.parent().find('.' + successClass).length) {
          successMessageContainer.appendTo(emailField.parent());
        }

        successMessageContainer.html(data.message.content).show();
        formElement.find('button:disabled').prop('disabled', false);
        kiwijs.SendNewsletterSuccessAnalyticsEvent(formElement.attr('eventLabel'));
      };

      this.error = function (data) {
        self.attachFormErrors(data.responseJSON.errors);
      };

      if (formActionUrl) {
        kiwijs.AjaxHandler.call(this, formElement, formActionUrl, this.success, this.error);
      }
    }
  };

  kiwijs.NewsletterPageAjaxHandler = function (formElement) {
    var self = this;
    var emailField = formElement.find('input[type=email]');
    var formActionUrl = formElement.attr('action');

    if (emailField.length && formActionUrl) {
      this.success = function (data) {
        formElement.closest('.main-content').replaceWith(data.message.content);
        kiwijs.SendNewsletterSuccessAnalyticsEvent(formElement.attr('eventLabel'));
      };

      this.error = function (data) {
        self.attachFormErrors(data.responseJSON.errors);
      };

      if (formActionUrl) {
        kiwijs.AjaxHandler.call(this, formElement, formActionUrl, this.success, this.error);
      }
    }
  };

  kiwijs.SendNewsletterSuccessAnalyticsEvent = function (eventLabel) {
    var event = new kiwijs.AnalyticsEvent();
    event.send('Newsletter Signup', 'Submit', eventLabel);
  };

  kiwijs.ajaxHandlers = {
    forms: {},
    initialize: function initialize() {
      var self = this;
      this.forms.loginForm = new kiwijs.LoginAjaxHandler($('#login-form-modal'));
      $.each($('.account-modal form[name="forgot_password"]'), function (index, formElement) {
        self.forms['forgotPasswordForm' + index] = new kiwijs.ForgotPasswordAjaxHandler($(formElement));
      });
      this.forms.resetPasswordForm = new kiwijs.ResetPasswordAjaxHandler($('#kc-validate-reset'));
      this.forms.registerForm = new kiwijs.RegisterAjaxHandler($('#account-register'));
      this.forms.verifyEmailLoginForm = new kiwijs.VerifyEmailAjaxHandler($('#verify-email-login-form-modal'));
      $.each($('.newsletter-inline-ajax'), function (index, formElement) {
        self.forms['newsletterInlineForm' + index] = new kiwijs.NewsletterInlineAjaxHandler($(formElement));
      });
      $.each($('.newsletter-page-ajax'), function (index, formElement) {
        self.forms['newsletterPageForm' + index] = new kiwijs.NewsletterPageAjaxHandler($(formElement));
      });
    }
  };
})(jQuery);

$(document).ready(function () {
  kiwijs.ajaxHandlers.initialize();
});

},{}]},{},[1]);
